import { createCrudApi } from './crud.api';
import { Bin } from '../types';

export const binsApi = createCrudApi<Bin>('/bank-bins');
